import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link } from 'react-router-dom';
import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';

import Toggle from 'react-toggle';
import InputMask from 'react-input-mask';
import Select from 'react-select';
import {ResponsiveContainer, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend } from 'recharts';

// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

//Modal
import StaffRfmsReportViewModal from './StaffRfmsReportViewModal';
import getLocale from '../../i18n/getLocale';


class StaffRfmsReportSearch extends Component {
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: null,
      total_daily: null,
      total_period: null,
      fatigue_incident: 0,
      staff_list: [],
      roles_list: [],
      bases_list: [],
      applicabilities_list: [],
      data_report_fatigues: [],
      date_start: '',
      date_finish: '',
      crew_visibility: {display: 'none'},
    };
    
    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.ActionsButtons = this.ActionsButtons.bind(this);
    this.loadData = this.loadData.bind(this);
    this.loadModal = this.loadModal.bind(this);
    this.showModal = this.showModal.bind(this);
    this.modalPropsOff = this.modalPropsOff.bind(this);
    this.searchReports = this.searchReports.bind(this);

    this.locale = getLocale();
  }

  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleToggleChange (name, event) {
    var change = {};
    if (event.target.checked === true) {
      var value = 1;
    } else {
      var value = 0;
    }
    change[name] = value;
    this.setState(change);
  } 
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }


  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;

      var header = this.refs.request_api.header('application/json');
      var self = this;
      this.handleAlert('', '', 'open');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/aplicabilidade/colaboradores/listagens/'+event.value, { method: 'GET', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.setState({
            roles_list: responseJson.data.roles,
            bases_list: responseJson.data.bases,
            staff_list: responseJson.data.staffs,
          });
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        });
      });
    }
    this.setState(change);
  }

  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event;
    }
    this.setState(change);
  }
  
  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }
  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorios-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({
            staff_list: responseJson.data.staff_list,
            roles_list: responseJson.data.roles_list,
            bases_list: responseJson.data.bases_list,
            applicabilities_list: responseJson.data.applicabilities_list,
          });
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  loadModal (value, event) {
    var self = this;
    var id = (value);
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/relatorio-de-fadiga/'+ id;
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          self.setState({data_report_fatigues:responseJson.data});
          self.showModal();
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
        self.modalPropsOff();
      }); /* Overlay */
    });
  }

  showModal (value, event) {
    this.setState({ modal_props: true});
  }
  modalPropsOff (event) {
    this.setState({ modal_props: false});
  }

  searchReports(event) {
    event.preventDefault();
    this.handleAlert('', '', 'open');
    var datasave = {
      staff: this.state.staff_ids,
      roles: this.state.roles_ids,
      date_start: this.state.date_start,
      date_finish: this.state.date_finish,
      bases: this.state.bases_ids,
      applicability_id: this.state.applicability_id,
    };

    var header = this.refs.request_api.header('application/json');
    var self = this;
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/relatorios-de-fadiga/buscar/diarias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          self.setState({data: responseJson.data.reports, total_daily: responseJson.data.total_daily, total_period: responseJson.data.total_period});
          self.setState({overlay: {message: '', type: '', status: 'closed'}});
        } else {
          self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
        }
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  

  ActionsButtons (cell, row) {    
    var botao = (
      <div className="btn-group">
        <button onClick={this.loadModal.bind(this, cell)} className='btn btn-sm btn-info' alt={this.locale.general.informacoes} title={this.locale.general.informacoes}><i className="fa fa-fw fa-eye"></i></button>
      </div>
    );

    return botao;
  }

  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  <div className="container-liquid">
    <div className="conteudo">
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.titulo}</h3>
      <hr/>
      <form onSubmit={this.searchReports}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.DataInicial}:</label>
              <InputMask value={this.state.date_start} required maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.DataFinal}:</label>
              <InputMask value={this.state.date_finish} required maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.AplicabilidadeTipoDeColaborador}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
                required
              />
            </div>
          </div>
          {this.state.applicability_id == 2 ?
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Mecanicos}:</label>
                  <Select
                    className="form-field-name"
                    name="staff_ids"
                    value={this.state.staff_ids}
                    searchable={true}
                    placeholder={this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarMecanicos}
                    onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                    options={this.state.staff_list}
                    multi={true}
                  />
                </div>
              </div>
            : this.state.applicability_id == 3 ?
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Coordenadores}:</label>
                  <Select
                    className="form-field-name"
                    name="staff_ids"
                    value={this.state.staff_ids}
                    searchable={true}
                    placeholder={this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarCoordenadores}
                    onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                    options={this.state.staff_list}
                    multi={true}
                  />
                </div>
              </div>
            :
              <div className="col-md-6">
                <div className="form-group">
                  <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Tripulantes}:</label>
                  <Select
                    className="form-field-name"
                    name="staff_ids"
                    value={this.state.staff_ids}
                    searchable={true}
                    placeholder={this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarTripulantes}
                    onChange={this.handleSelectChange.bind(this, 'staff_ids')}
                    options={this.state.staff_list}
                    multi={true}
                  />
                </div>
              </div>
          }
        </div>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Cargos}:</label>
              <Select
                className=""
                name="roles_ids"
                value={this.state.roles_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarCargos}
                onChange={this.handleSelectChange.bind(this, 'roles_ids')}
                options={this.state.roles_list}
              />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.Bases}:</label>
              <Select
                className=""
                name="bases_ids"
                value={this.state.bases_ids}
                searchable={true}
                multi={true}
                placeholder={this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.placeholder.SelecionarBases}
                onChange={this.handleSelectChange.bind(this, 'bases_ids')}
                options={this.state.bases_list}
              />
            </div>
          </div>
        </div>
        <div>
          <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-search"></i> {this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.formulario.botaoProcurarRelatarios}</button>
        </div>
      </form>
      <hr/>
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tituloTotalDoPeriodo}</h3>
      <hr/>
      <BootstrapTable data={this.state.total_period} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.semParametrosDeFadiga}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn isKey={true} dataField="not_fatigue" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.NaoFadigados}</TableHeaderColumn>
        <TableHeaderColumn dataField="blue_fatigue" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.PontosAzul}</TableHeaderColumn>
        <TableHeaderColumn dataField="yellow_fatigue" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.PontosAmarelo}</TableHeaderColumn>
        <TableHeaderColumn dataField="red_fatigue" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDoPeriodo.PontosVermelho}</TableHeaderColumn>

      </BootstrapTable>
      <hr/>
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tituloTotalDiario}</h3>
      <hr/>
      <BootstrapTable data={this.state.total_daily} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.semParametrosDeFadiga}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn isKey={true} dataField="date" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="not_fatigue" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.NaoFadigados}</TableHeaderColumn>
        <TableHeaderColumn dataField="blue_fatigue" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.PontosAzul}</TableHeaderColumn>
        <TableHeaderColumn dataField="yellow_fatigue" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.PontosAmarelo}</TableHeaderColumn>
        <TableHeaderColumn dataField="red_fatigue" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaTotalDiario.PontosVermelho}</TableHeaderColumn>

      </BootstrapTable>
      <hr/>
      <h3 className="page-title">{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tituloListaDeRelatoriosDeFadigas}</h3>
      <hr/>
      <BootstrapTable data={this.state.data} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: this.locale.general.exportarTextoCSV, noDataText: this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.semParametrosDeFadiga}} search={true} multiColumnSearch={true}  searchPlaceholder={this.locale.general.procurar}>

        <TableHeaderColumn isKey={true} dataField="date_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Data}</TableHeaderColumn>
        <TableHeaderColumn dataField="revision" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Revisao}</TableHeaderColumn>
        <TableHeaderColumn dataField="staff_name" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Tripulante}</TableHeaderColumn>
        <TableHeaderColumn dataField="day_off_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Folga}</TableHeaderColumn>
        <TableHeaderColumn dataField="actual_points_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.QuantidadeDePontosAtual}</TableHeaderColumn>
        <TableHeaderColumn dataField="report_points_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.QuantidadeDePontosReportados}</TableHeaderColumn>
        <TableHeaderColumn dataField="created_at_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: this.locale.general.procurar}}>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.DiaDePreenchimento}</TableHeaderColumn>

        <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.ActionsButtons} width='100'>{this.locale.RelatoriosDeFadiga.PesquisaDeRelatorios.tabelaListaDeRelatoriosDeFadigas.Acoes}</TableHeaderColumn>

      </BootstrapTable>
      <StaffRfmsReportViewModal handleAlert={self.props.handleAlert} modal_props={self.state.modal_props} staff_name={self.state.staff_name} data_report_fatigues={self.state.data_report_fatigues} />
    </div>
  </div>
</div>
    );
  }
}

export default StaffRfmsReportSearch;



// WEBPACK FOOTER //
// ./src/Components/StaffRfmsReport/StaffRfmsReportSearch.js